import { useState, ReactNode } from 'react';
import cs from 'classnames';
import kebabCase from 'lodash/kebabCase';
import {
  Typography,
  DetailListItem,
  Tooltip,
  InfoCircleIcon,
} from '@forgeglobal/design-framework';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { useStyles } from './style';

interface Props {
  label: string;
  value?: string;
  className?: string;
  children?: ReactNode;
  isPrivate?: boolean;
  infoText?: string;
}

const DetailCardItem = ({
  label,
  value,
  className,
  children,
  isPrivate = false,
  infoText,
}: Props) => {
  const classes = useStyles();
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);

  const info = (
    <ClickAwayListener onClickAway={() => setTooltipIsOpen(false)}>
      <Tooltip
        open={tooltipIsOpen}
        onOpen={() => setTooltipIsOpen(true)}
        onClose={() => setTooltipIsOpen(false)}
        classes={{
          tooltip: classes.tooltip,
          arrow: classes.tooltipArrow,
        }}
        title={
          <Typography variant="caption" className={classes.tooltipTypography}>
            {infoText}
          </Typography>
        }
        placement="top"
        arrow>
        <div className={classes.infoWrapper}>
          <InfoCircleIcon
            className={classes.infoIcon}
            onClick={() => setTooltipIsOpen(true)}
          />
        </div>
      </Tooltip>
    </ClickAwayListener>
  );

  return (
    <DetailListItem
      label={
        <div className={classes.labelWrapper}>
          <Typography
            variant="body1"
            color="textSecondary"
            className={classes.text}>
            {label}
          </Typography>
          {infoText && info}
        </div>
      }
      content={
        value && (
          <Typography
            variant="body1"
            data-test-id={kebabCase(label)}
            data-private={isPrivate || null}>
            {value}
          </Typography>
        )
      }
      className={cs(classes.listItem, className)}>
      {children}
    </DetailListItem>
  );
};

export default DetailCardItem;
